import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { AvonIcon, Button as AvonButton } from '@avon/component-library';
import { func, object } from 'prop-types';
import successIcon from '../assets/successIcon.svg';
import { isMobile } from '../../../utils/getDeviceType';
import { getSSO } from '../../../utils/api/endpoints';

const useStyles = makeStyles(theme => ({
  wrapper: e => (e.isMobile ? {
    padding: '40px 16px 12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 64,
      height: 64,
    },
    height: 'calc(100% - 120px)',
  } : {
    padding: '60px 60px 53px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 84,
      height: 84,
    },
  }),
  title: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '22px',
    lineHeight: '30px',
    textAlign: 'center',
    color: '#1A8282',
    margin: '30px 0 12px',
  } : {
    fontFamily: 'Montserrat-Light',
    fontSize: '42px',
    lineHeight: '54px',
    textAlign: 'center',
    color: '#1A8282',
    margin: '30px 0 24px',
  }),
  desc: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#707677',
  } : {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    lineHeight: '26px',
    textAlign: 'center',
    color: '#546264',
  }),
  contactWrapper: e => (e.isMobile ? {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '14px 0',
    width: '100%',
    height: 62,
  } : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 0',
    width: '100%',
  }),
  contactContainer: {
    color: theme.palette.colors.corePink,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  socialText: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.colors.corePink,
    paddingLeft: 10,
  } : {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.colors.corePink,
    paddingLeft: 10,
  }),
  contentBox: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  mobileButtonBox: e => (e.isMobile ? {
    position: 'fixed',
    bottom: 0,
    padding: '12px 16px',
  } : {
    width: '100%',
    marginTop: 42,
  }),
}));

const SuccessDetail = ({
  setclickId,
  notifycationDetail: {
    contentMap, email, mobile, category, ssoActive,
  },
  snsInfo: { button, info = {} },
  callApi,
}) => {
  const classes = useStyles({ language: 'not ar', isMobile: isMobile() });
  const theme = useTheme();

  const getSSOLink = async (authAppType, landingPage) => {
    const resp = await callApi(getSSO(authAppType, landingPage));
    const params = resp.params.reduce((ret, param) => `${ret}${ret.length > 0 ? '&' : ''}${param.name}=${param.value}`, '');
    const link = `${resp.url}?${params}`;
    return link;
  };

  const handleNavigateOffice = () => {
    getSSOLink('MAO', 'login').then((link) => {
      window.open(link, 'sso');
    });
  };

  return (
    <Box className={classes.wrapper}>
      <div className={classes.contentBox}>
        <img
          src={successIcon}
          alt="success-icon"
        />
        <Box className={classes.title}>
          {info[category]}
        </Box>
        {
        contentMap && contentMap.content0 && (
          <Box className={classes.desc}>
            {contentMap.content0}
          </Box>
        )
      }
        <Box className={classes.contactWrapper}>
          <Box className={classes.contactContainer} component="a" href={`tel:${mobile}`}>
            <AvonIcon
              color={theme.palette.colors.corePink}
              type="phone"
              alt="phone-icon"
              height="24px"
              width="24px"
            />
            <Box className={classes.socialText}>
              {mobile}
            </Box>
          </Box>
          <Box className={classes.contactContainer} component="a" href={`mailto:${email}`}>
            <AvonIcon
              color={theme.palette.colors.corePink}
              type="email"
              alt="email-icon"
              height="24px"
              width="24px"
            />
            <Box className={classes.socialText}>
              {email}
            </Box>
          </Box>
        </Box>
        {
        contentMap && contentMap.content1 && (
          <Box className={classes.desc}>
            {contentMap.content1}
          </Box>
        )
      }
      </div>
      {isMobile()
        ? (
          <Box width="100%" mt={12} className={classes.mobileButtonBox}>
            {
            ssoActive && (
              <Box style={{ width: '100%' }}>
                <AvonButton priority="secondary" onClick={handleNavigateOffice}>{button.viewInOffice}</AvonButton>
              </Box>
            )
          }
            <Box style={{ width: '100%', marginTop: 12 }}>
              <AvonButton priority="tertiary" onClick={() => setclickId('')}>{button.close}</AvonButton>
            </Box>
          </Box>
        )
        : (
          <Box width="100%" mt={12} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            {
            ssoActive && (
              <Box flex={1} style={{ width: '50%' }}>
                <AvonButton priority="secondary" onClick={handleNavigateOffice}>{button.viewInOffice}</AvonButton>
              </Box>
            )
          }
            <Box flex={1} style={{ width: '50%', paddingRight: 10 }}>
              <AvonButton priority="tertiary" onClick={() => setclickId('')}>{button.close}</AvonButton>
            </Box>
          </Box>
        )
      }

    </Box>
  );
};

SuccessDetail.propTypes = {
  notifycationDetail: object,
  setclickId: func,
  snsInfo: object,
  callApi: func,
};

export default SuccessDetail;
